


























































import { Vue, Component, Prop, Emit } from "vue-property-decorator"
import api from "../honcierge-api"
import { AxiosError } from "axios"
import { AppAffiliate } from "types/appAffiliate"

@Component
export default class EditAppAffiliate extends Vue {
  @Prop()
  private dialog!: boolean

  public id: AppAffiliate["data"]["id"] = -1 // 正なら新規作成, そうでないなら更新処理を行う
  public name = ""
  public label = ""
  public isEnabled = false

  // rules for form
  private nameRules = [(name: string) => !!name || "名前は必須です"]
  private labelRules = [(label: string) => !!label || "ラベルは必須です"]

  public updateAppAffiliate(): void {
    if (!this.validate()) {
      return
    }
    api
      .updateAppAffiliate({
        id: this.id,
        name: this.name,
        label: this.label,
        isEnabled: this.isEnabled,
      })
      .then((res) => {
        this.emitAppAffiliate(res.data.appAffiliate)
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 422) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  public createAppAffiliate(): void {
    if (!this.validate()) {
      return
    }
    api
      .createAppAffiliate({
        name: this.name,
        label: this.label,
        isEnabled: this.isEnabled,
      })
      .then((res) => {
        this.emitAppAffiliate(res.data.appAffiliate)
      })
      .catch((e: AxiosError) => {
        if (e.response?.status === 422) {
          this.$toasted.error(e.response.data.messages)
        }
      })
  }

  @Emit("emitAppAffiliate")
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private emitAppAffiliate(appAffiliate: AppAffiliate["data"]) {
    this.close()
  }

  @Emit("close")
  private close() {
    this.clear()
  }

  private validate(): boolean {
    const form = this.$refs.form as InstanceType<typeof EditAppAffiliate>
    return form.validate()
  }

  private resetValidation(): void {
    const form = this.$refs.form as InstanceType<typeof EditAppAffiliate>
    return form.resetValidation()
  }

  private clear() {
    this.init()
    this.resetValidation()
  }

  private init() {
    this.id = -1
    this.name = ""
    this.label = ""
    this.isEnabled = false
  }
}
